import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AllocationFromHistoryRow from '../AllocationFromHistoryRow';
import useStyles from '../../AllocationProgress/styles';
const AllocationFromHistoryTable = observer(_ref => {
  let utilities = _ref.utilities,
    subMeterUtilitiesFinalStates = _ref.subMeterUtilitiesFinalStates,
    propertyData = _ref.propertyData,
    cycleName = _ref.cycleName;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.table
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "allocation table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, t('allocations.utility')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.service_start')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.service_end')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.bill_value')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.cellWithHint
  }, t('allocations.cad'), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('allocations.cad_hint'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.cellWithHint
  }, t('allocations.gwd'), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('allocations.gwd_hint'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.ratio_billed')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.total')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.status')))), /*#__PURE__*/React.createElement(TableBody, null, utilities.map(utility => /*#__PURE__*/React.createElement(AllocationFromHistoryRow, {
    key: utility.utilityId + utility.billingCycleId,
    utility: utility,
    subMeterFinalState: subMeterUtilitiesFinalStates !== null ? subMeterUtilitiesFinalStates[utility.utilityId] : null,
    propertyData: propertyData,
    cycleName: cycleName
  }))))));
});
export default AllocationFromHistoryTable;